import React, {useContext} from 'react';
import {CircularProgress, Box} from '@mui/material';
import {ViewContext} from '../Context/ViewContext';

export const LoaderComponent = ({loadingPage =false}) => {
    const {loader} = useContext(ViewContext)

    if (!loader && !loadingPage) return null;

    return (
        <Box display="flex" className="loader" flexDirection="column" alignItems="center" justifyContent="center"
             height="100vh">
            <CircularProgress color="secondary"/>
        </Box>
    );
};

export default LoaderComponent;